










































/* General */
import Vue from 'vue'
import MailboxVerificationLayout from '@/layouts/mailbox-verification-layout.vue'

/* Mixins */

/* Components */
import EntitySettingsLoading from '@/layouts/entity-settings-loading.vue'

/* Helpers */
import RouteAssistant from '@/helpers/route-assistant'
import ColorAssistant from '@/helpers/color-assistant'
import LocalStore from '@/helpers/localstore'

/* Data types */

/* API */
import MailboxesAPI from '@/api/modules/mailboxes.api'

export default Vue.extend({
  metaInfo: {
    title: 'Set up Auto-Forwarding',
  },

  components: {
    MailboxVerificationLayout,
    EntitySettingsLoading,
  },

  data() {
    return {
      RouteAssistant,
      ColorAssistant,
      LocalStore,
      mailboxName: '',
      isLoading: true,
      isSubmitting: false,
      emailValidated: false,
      forwardingAddress: '',
    }
  },

  computed: {
    mailboxID(): number {
      return Number(this.$route.params.id)
    },
    disableSubmit(): boolean {
      return !this.emailValidated
    },
  },

  async created() {
    this.isLoading = true
    await this.getMailboxName()
    this.isLoading = false
  },

  methods: {
    async getMailboxName() {
      try {
        const response = await MailboxesAPI.get_Title(this.mailboxID)
        this.mailboxName = response.name
      } catch (err) {
        this.$error.emit(err)
      }
    },
    async addAutoForwardingAddress() {
      LocalStore.mailboxForwardingAddressCandidate = this.forwardingAddress
      RouteAssistant.goToMailboxVerificationAutoForwardingRoute(
        this.$router,
        this.$route.params.accountId,
        this.mailboxID,
      )
    },
  },
})
